var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.reporting),expression:"reporting"}],staticClass:"btn btn-wd btn-fill btn-tertiary",on:{"click":_vm.loadingReport}},[_vm._v("\n  Gerar relatório geral: "+_vm._s(_vm.eventLabel)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da37904e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/GlobalRankingReport2.vue
// module id = C14H
// module chunks = 10